// import React from "react";
// import { Navigate } from "react-router-dom";
// import { getAuth } from "firebase/auth";

// const auth = getAuth();

// const PrivateRoute = ({ children }) => {
//   if (!auth.currentUser) {
//     return <Navigate to="/" />; // Redirect to login if user is not authenticated
//   }
//   return children; // If authenticated, render the children (Body component)
// };

// export default PrivateRoute;


import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";

const PrivateRoute = ({ children }) => {
  const auth = getAuth();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // Track loading state

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (loggedInUser) => {
      setUser(loggedInUser);
      setLoading(false); // Auth state has been determined
    });

    return () => unsubscribe(); // Cleanup listener on unmount
  }, [auth]);

  if (loading) {
    return <p>Loading...</p>; // Prevent redirecting while checking auth state
  }

  return user ? children : <Navigate to="/" />;
};

export default PrivateRoute;
